module.exports = __webpack_public_path__ + "img/reply-icon.8a454368.svg";